import styled from "styled-components";

export const ArrowsContainer = styled.div`
  position: fixed;
  right: 18px;
  bottom: 24px;
  z-index: 1100;

  @media (max-width: 767px) {
    display: none; /* solo tablet/desktop */
  }
`;

export const ButtonsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ArrowBtn = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid var(--color-latex30);
  background: var(--color-white);
  color: var(--color-latex30);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
    rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  font-size: 22px;

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
`;
